export default __webpack_public_path__ + "static/media/big.616990b9.png";